import React, { Component } from "react";
import { DelayReasonModel } from "../../models";
import { TextField, FontIcon } from "@fluentui/react";

interface IProp {
  model: DelayReasonModel;
  disabled: boolean | undefined;
  onSelectionChange: (val: string) => void;
}

interface IState {
  isOtherSelected: boolean;
  selectedValue: string;
}

class DelayReasonsGrid extends Component<IProp, {}> {
  state = {
    selectedValue: "",
    isOtherSelected: false,
  } as IState;

  optionButtonHandler = (val: string) => {
    let value = val.toLowerCase() === "other" ? "" : val;

    this.setState({
      isOtherSelected: val.toLowerCase() === "other",
      selectedValue: value,
    });
    this.props.onSelectionChange(value);
  };

  render() {
    const { model, disabled } = this.props;
    const { selectedValue, isOtherSelected } = this.state;

    return (
      <div style={{ textAlign: "left" }}>
        <span style={{ fontSize: "14px" }}>Please select delay reason.</span>

        <div className="ms-Grid" dir="ltr" style={{ padding: "0" }}>
          <div className="ms-Grid-row">
            {model.options.map((reason) => (
              <div
                className="ms-Grid-col ms-md6"
                style={{ paddingLeft: "0px" }}
              >
                <div className="action-buttons">
                  <button
                    id={`btn-reason-${reason}`}
                    //  className={`option-grid ${
                    //   reason === selectedValue ? "selected" : ""
                    // }`}
                    style={{
                      backgroundColor: `${
                        reason === selectedValue ||
                        (reason === "Other" && isOtherSelected)
                          ? "#eeeeee"
                          : ""
                      }`,
                    }}
                    disabled={disabled}
                    onClick={() => this.optionButtonHandler(reason)}
                  >
                    <table>
                      <tr>
                        <td>
                          <FontIcon
                            iconName={
                              reason === selectedValue ||
                              (reason === "Other" && isOtherSelected)
                                ? "RadioBtnOn"
                                : "RadioBtnOff"
                            }
                            style={{ fontSize: "12px", display: "inlineBlock" }}
                          />
                          &nbsp;
                        </td>
                        <td> {reason}</td>
                      </tr>
                    </table>
                  </button>
                </div>
              </div>
            ))}

            {isOtherSelected && (
              <div className="ms-Grid-col ms-sm12">
                <TextField
                  id="txt-other-reason"
                  label="Delay Reason"
                  placeholder="Delay reason is required."
                  multiline
                  disabled={disabled}
                  onChange={(event, value) => {
                    this.setState({ selectedValue: value });
                    this.props.onSelectionChange(value ? value : "");
                  }}
                ></TextField>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default DelayReasonsGrid;
